import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './ActionConfirmModal.scss';

/**
 * Generic confirmation dialog for destructive / important actions (not export-specific).
 *
 * @param {object} props
 * @param {boolean} props.show
 * @param {() => void} props.onHide
 * @param {() => void} props.onConfirm
 * @param {string} props.title
 * @param {string} [props.subtitle]
 * @param {React.ReactNode} [props.headerIcon] optional icon node (e.g. FontAwesome)
 * @param {React.ReactNode} props.children body content
 * @param {string} [props.cancelLabel='Cancel']
 * @param {string} [props.confirmLabel='Confirm']
 * @param {boolean} [props.confirmDisabled]
 * @param {'sm'|'md'|'lg'} [props.size='md']
 * @param {boolean|string} [props.backdrop='static']
 * @param {boolean} [props.keyboard=true]
 * @param {string} [props.titleId] for aria-labelledby
 */
export default function ActionConfirmModal({
  show,
  onHide,
  onConfirm,
  title,
  subtitle,
  headerIcon,
  children,
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  confirmDisabled = false,
  size = 'md',
  backdrop = 'static',
  keyboard = true,
  titleId = 'action-confirm-modal-title',
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size={size}
      backdrop={backdrop}
      keyboard={keyboard}
      className="action-confirm-modal"
      contentClassName="action-confirm-modal__surface"
      dialogClassName="action-confirm-modal__dialog"
      aria-labelledby={titleId}
    >
      <Modal.Header closeButton className="action-confirm-modal__header border-0">
        <div className="d-flex align-items-start gap-3 w-100 pe-1">
          {headerIcon ? <div className="action-confirm-modal__header-icon">{headerIcon}</div> : null}
          <div className="flex-grow-1 min-w-0">
            <Modal.Title id={titleId} as="h2" className="action-confirm-modal__title">
              {title}
            </Modal.Title>
            {subtitle ? <p className="action-confirm-modal__subtitle mt-2 mb-0">{subtitle}</p> : null}
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="action-confirm-modal__body">{children}</Modal.Body>
      <Modal.Footer className="action-confirm-modal__footer border-0 d-flex flex-wrap justify-content-end">
        <button
          type="button"
          className="btn action-confirm-modal__btn action-confirm-modal__btn--secondary"
          onClick={onHide}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className="btn action-confirm-modal__btn action-confirm-modal__btn--primary"
          onClick={onConfirm}
          disabled={confirmDisabled}
        >
          {confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
